module.exports = __webpack_public_path__ + "static/groceries-ca8fa089339b62958689bb713f88211b.png";